const cards = [
  {
    title: '鬼灭之刃',
    subtitle: '吾峠呼世晴 · 热血冒险',
    desc: '大正时代，少年灶门炭治郎全家被鬼杀害，妹妹祢豆子变成了鬼。为了寻找让妹妹变回人类的方法，炭治郎踏上了成为鬼杀队员的道路。',
    tag: '连载中',
    hot: '热度第一',
    image: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20young%20swordsman%20with%20green%20checkered%20haori%20coat%20holding%20a%20katana%2C%20water%20dragon%20effect%20surrounding%20him%2C%20dramatic%20pose%2C%20moon%20in%20background%2C%20Japanese%20woodblock%20print%20inspired%20style%2C%20bold%20crimson%20and%20dark%20blue%20tones&width=600&height=800&seq=card-comic-01&orientation=portrait',
  },
  {
    title: '咒术回战',
    subtitle: '芥见下下 · 黑暗奇幻',
    desc: '高中生虎杖悠仁吞下诅咒之王的手指后，被卷入咒术师与诅咒的战斗世界。在东京都立咒术高专，他与同伴们直面越来越强大的诅咒。',
    tag: '连载中',
    hot: '热度第二',
    image: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20teenager%20with%20pink%20spiky%20hair%20in%20a%20school%20uniform%2C%20dark%20energy%20swirling%20around%20his%20fist%2C%20urban%20cityscape%20background%2C%20bold%20red%20and%20black%20color%20scheme%2C%20dynamic%20action%20pose%2C%20modern%20anime%20art%20style&width=600&height=800&seq=card-comic-02&orientation=portrait',
  },
  {
    title: '海贼王',
    subtitle: '尾田荣一郎 · 冒险热血',
    desc: '少年蒙奇·D·路飞立志成为海贼王，与伙伴们在大海贼时代展开波澜壮阔的冒险。找到传说中的大秘宝ONE PIECE，实现各自的梦想。',
    tag: '连载中',
    hot: '经典长篇',
    image: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20young%20pirate%20with%20a%20straw%20hat%20grinning%20widely%2C%20stretching%20his%20rubber%20arm%20forward%2C%20pirate%20ship%20in%20background%20on%20blue%20ocean%2C%20bright%20sky%20with%20clouds%2C%20energetic%20and%20adventurous%20feel%2C%20warm%20colors&width=600&height=800&seq=card-comic-03&orientation=portrait',
  },
  {
    title: '间谍过家家',
    subtitle: '远藤达哉 · 家庭喜剧',
    desc: '间谍父亲、杀手母亲、读心术女儿——三个各怀秘密的人组成虚假家庭。为了世界和平，这个非日常家庭的日常喜剧正式开幕！',
    tag: '连载中',
    hot: '人气飙升',
    image: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20stylish%20family%20of%20three%20in%20formal%20attire%2C%20a%20man%20in%20suit%20with%20a%20gun%20hidden%2C%20a%20woman%20with%20elegant%20dress%2C%20a%20little%20girl%20with%20pink%20hair%2C%20European%20city%20backdrop%2C%20warm%20and%20playful%20tone&width=600&height=800&seq=card-comic-04&orientation=portrait',
  },
  {
    title: '葬送的芙莉莲',
    subtitle: '山田钟人 · 治愈奇幻',
    desc: '打倒魔王的勇者队伍中的精灵魔法使芙莉莲，在伙伴们相继离世后，踏上了理解人类情感的旅程。一场关于时间、生命与羁绊的温柔故事。',
    tag: '连载中',
    hot: '口碑神作',
    image: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20an%20elf%20mage%20with%20long%20silver%20hair%20holding%20a%20staff%2C%20standing%20in%20a%20field%20of%20wildflowers%20at%20golden%20hour%2C%20gentle%20expression%2C%20fantasy%20adventure%20feel%2C%20soft%20pastel%20colors%2C%20nostalgic%20mood&width=600&height=800&seq=card-comic-05&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            精彩推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            编辑精选优质免费漫画，每部都值得一读
          </p>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((card) => (
              <div
                key={card.title}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="text-xs px-2.5 py-1 rounded-full bg-primary-500 text-background-50 font-medium">
                      {card.hot}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <div className="flex items-center justify-between">
                    <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors">
                      {card.title}
                    </h3>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                      {card.tag}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-500">{card.subtitle}</p>
                  <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {card.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}